import { Component, EventEmitter, Input, Output } from '@angular/core';

import { CLIENT_THEME, ClientTheme } from 'src/app/features/client/';

@Component({
    selector: 'app-branding',
    templateUrl: './branding.component.html',
    styleUrls: ['./branding.component.scss'],
    standalone: false
})
export class BrandingComponent {
  @Input() showDropdown: boolean;
  @Output() showDropdownChange = new EventEmitter<boolean>();

  clientTheme: ClientTheme;

  public get dropDownIcon() {
    return this.showDropdown ? 'mobile-expand-less' : 'mobile-expand-more';
  }

  constructor() {
    this.clientTheme = CLIENT_THEME;
  }

  toggleDropdown() {
    this.showDropdown = !this.showDropdown;
    this.showDropdownChange.emit(this.showDropdown);
  }
}
